import { DbMongoBaseInfos } from "./db-mongo-base-infos";

export class DbUserBasicInfos extends DbMongoBaseInfos {
  enabled: boolean = false;
  deleted: boolean = false;
  groupId: number = 0;
  firstName: string | null = null;
  lastName: string | null = null;
  email: string | null = null;
  name: string | null = " ";
  login: string = "";

  constructor(init?: Partial<DbUserBasicInfos>) {
    super();
    Object.assign(this, init);
  }
}
